import React, { useRef, useState } from "react";

import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; // Ensure react-icons is installed

const causesData = [
  {
    title: "ANTI-ADDICTION",
    image: "/assets/causes/1.jpg",
    description: "Rehabilitation services and support initiatives.",
  },
  {
    title: "EDUCATION",
    image: "/assets/causes/2.jpg",
    description: "Empowering individuals through quality vocational training.",
  },
  {
    title: "DISASTER RELIEF",
    image: "/assets/causes/3.jpg",
    description: "Immediate welfare support for affected communities.",
  },
  {
    title: "ECO PROTECTION",
    image: "/assets/causes/4.jpg",
    description: "Sustainable practices to preserve our planet.",
  },
  {
    title: "INDIVIDUAL CARE",
    image: "/assets/causes/5.jpg",
    description: "Personalized support ensuring dignity and well-being.",
  },
  {
    title: "VALUE AWARENESS",
    image: "/assets/causes/6.jpg",
    description: "Promoting ethical values and social responsibility.",
  },
];

const OurCauses = () => {
  const sliderRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(true);

  // Scroll Handler to toggle arrow visibility
  const handleScroll = () => {
    if (sliderRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = sliderRef.current;
      setShowLeftArrow(scrollLeft > 0);
      setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 10);
    }
  };

  const scroll = (direction) => {
    if (sliderRef.current) {
      const scrollAmount = 320; // Width of card + gap
      sliderRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <section className="premium-causes-section">
      <div className="causes-header-compact">
        <h2 className="premium-heading">OUR CAUSES</h2>
        <div className="heading-line"></div>
      </div>

      <div className="slider-wrapper">
        {/* Navigation Arrows */}
        {showLeftArrow && (
          <button className="nav-arrow left" onClick={() => scroll("left")}>
            <FaChevronLeft />
          </button>
        )}

        {/* The Horizontal Scroll Container */}
        <div className="causes-slider" ref={sliderRef} onScroll={handleScroll}>
          {causesData.map((cause, index) => (
            <div className="cause-card-compact" key={index}>
              <div className="card-image-wrapper">
                <img src={cause.image} alt={cause.title} loading="lazy" />
                <div className="card-overlay"></div>
              </div>

              <div className="card-content-compact">
                <h3 className="card-title">{cause.title}</h3>
                <p className="card-desc">{cause.description}</p>
                <span className="card-arrow"> </span>
              </div>
            </div>
          ))}

          {/* Padding element for right side scroll */}
          <div className="spacer-end"></div>
        </div>

        {showRightArrow && (
          <button className="nav-arrow right" onClick={() => scroll("right")}>
            <FaChevronRight />
          </button>
        )}
      </div>
    </section>
  );
};

export default OurCauses;
